module.exports = __webpack_public_path__ + "img/featurePlan.75d02542.png";